module.exports = __webpack_public_path__ + "static/media/main_slider_1.8e6a500f.jpg";